import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutGrid } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

import { z } from 'zod';

export const ResultsWrapper: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;

  const configSchema = z.optional(
    z.object({
      columns: z.number(),
      space: z.any(),
      bexQuickFiltersEnabled: z.optional(z.boolean()),
    })
  );

  const result = configSchema.safeParse(config);

  if (!result.success || !children || children.length === 0) {
    return null;
  }

  const { columns, space, bexQuickFiltersEnabled } = result.data ?? {};

  return (
    <UitkSpacing
      padding={
        bexQuickFiltersEnabled
          ? {
              blockstart: 'two',
            }
          : {
              small: { block: 'three' },
              medium: { blockstart: 'one' },
              large: { blockstart: 'three' },
            }
      }
    >
      <div className="search-results-listing">
        <Viewport>
          <ViewLarge>
            <UitkLayoutGrid columns={columns} space={space}>
              {children && <ExperienceTemplateRenderer templateComponents={children} />}
            </UitkLayoutGrid>
          </ViewLarge>
          <ViewSmall>
            <UitkLayoutGrid columns={1}>{children && <ExperienceTemplateRenderer templateComponents={children} />}</UitkLayoutGrid>
          </ViewSmall>
        </Viewport>
      </div>
    </UitkSpacing>
  );
};
